import { DefaultLoadingManager, ImageLoader, Mesh, PlaneGeometry, Texture, RGBAFormat, MeshBasicMaterial } from "three";
import { FacetRenderer } from "../rendering/renderable/Renderable";
import { Matrix4 } from "flavr-math";
import { ControllerRenderable } from "../rendering/controller/ControllerRenderable";
import { RenderOrder } from "../rendering/RenderOrder";
const tmpMatrix4 = new Matrix4();
const BACKGROUND_IMAGE = "img/record.png";
const planeGeometry = new PlaneGeometry(1, 1, 1, 1);
const imageLoader = new ImageLoader(DefaultLoadingManager);
imageLoader.setCrossOrigin("anonymous");
const backgroundTexure = new Texture();
imageLoader.load(BACKGROUND_IMAGE, (image) => {
    backgroundTexure.image = image;
    backgroundTexure.format = RGBAFormat;
    backgroundTexure.needsUpdate = true;
});
export class RecordIndicatorRenderer extends FacetRenderer {
    destroy() {
        if (this.mesh) {
            this.mesh.parent && this.mesh.parent.remove(this.mesh);
        }
        if (this.material) {
            this.material.dispose();
        }
    }
    setVisible(visible) {
        if (this.mesh)
            this.mesh.visible = visible;
    }
    updateFacet(facet) {
        if (!this.material) {
            this.material = new MeshBasicMaterial({
                color: 0xffffff,
                transparent: true,
                map: backgroundTexure,
                opacity: 0.99
            });
        }
        if (!this.mesh) {
            this.mesh = new Mesh(planeGeometry, this.material);
            this.mesh.matrixAutoUpdate = false;
            this.mesh.matrixWorldNeedsUpdate = false;
            this.mesh.renderOrder = RenderOrder.TRANSPARENT_GEOMETRY;
            this.owner.renderer.addToScene(this.mesh, this.owner.modelUID);
            this.updateTransform();
        }
        this.material.color.setHSL(0, 0, 0.2 + 0.8 * facet.volume);
    }
    updateTransform() {
        if (!this.mesh)
            return;
        tmpMatrix4.copy(this.owner.matrixWorld);
        const renderable = this.owner.getRenderableByType(ControllerRenderable);
        if (renderable) {
            const info = renderable.controllerInfo;
            if (info) {
                tmpMatrix4.compose(info.recordIndicator.position, info.recordIndicator.orientation, info.recordIndicator.scale);
                tmpMatrix4.premultiply(this.owner.matrixWorld);
            }
        }
        this.mesh.matrixWorld.copy(tmpMatrix4);
        this.mesh.matrixWorldNeedsUpdate = false;
    }
}
